import { ChosenOption, FixMe, Option } from '@greenkub-fronts/shared/interface';
import { cloneDeep, get } from 'lodash';

/**
 * Détermine si le model correspondant à l'id passé est une extension
 *
 * @param {*} models
 * @param {string} odooId
 */
export const isExtension = (models, odooId) => {
  if (!odooId) {
    return false;
  }

  const model = models.find((m) => m.odooId.toString() === odooId.toString());

  if (!model) {
    return false;
  }

  return model.category === 'extension';
};

/**
 * Récupère les prix des configurations à partir des données brute du projet
 *
 * @param {any} project
 * @return {number[]}
 */
export const getPrices = (project) => {
  (get(project, 'configurations') ?? []).map((c) => {
    const quantity = Number(get(c, 'quantity') ?? 1);
    const modelPrice = Number(get(c, 'model.unitPrice') ?? 0);
    const optionsPrice = (get(c, 'options') ?? []).reduce(
      (accu, o) => accu + Number(get(o, 'unitPrice') ?? 0),
      0
    );

    const total = quantity * (modelPrice + optionsPrice);
    return Number(total.toFixed(0)); //not sure about the rounding here
  });
};

export default getPrices;

export const chosenOptionListBuilder = (
  catalogue: Option,
  quantity: number
) => {
  const chosenOption: ChosenOption[] = [];

  for (let i = 0; i < quantity; i++) {
    chosenOption.push(cloneDeep(catalogue as FixMe));
  }

  return {
    chosenOption,
    totalPrice: catalogue.unitPrice * quantity,
    totalVat: catalogue.vat * quantity,
    totalPriceWithVat: catalogue.unitPriceWithVat * quantity,
    catalogue,
  };
};
